<template>
  <div class="flex flex-col flex-start items-center flex-wrap xl:flex-nowrap">
    <div class="reservation-text">
      <h2 class="heading-2 color-black text-center mb-6"></h2>
      <span></span>
      <span class="mt-2">{{ boardingText }}</span>
      <div class="code">
        <span class="font-bold">{{ $t('reservation_area.reservation_code') }}:</span>
        <span class="font-bold turquoiseBlue">{{ reservationCode }}</span>
      </div>
    </div>
    <div v-if="!(boarding_passes.length > 0)" class="forms-container">
      <div class="w-full space-y-5">
        <app-box-header
          v-for="(item, index) in passengers"
          :key="index"
          :title="getPassengerLabel(item.type, index)"
        >
          <app-form-adult
            :refId="'formAdult' + (index + 1)"
            :ref="'formAdult' + (index + 1)"
            :formProp="item"
          ></app-form-adult>
        </app-box-header>
      </div>
      <v-btn
        color="secondary"
        :loading="loading"
        rounded
        class="save-reservation-btn"
        large
        @click="handleSaveData"
        :disabled="loading"
        >{{ $t('reservation_area.save_info') }}</v-btn
      >
    </div>
    <div class="boarding-container">
      <div
        v-for="(boarding, index) in boarding_passes"
        :key="index"
        class="boarding-pass"
      >
        <span class="font-bold">{{ $t('reservation_area.trip_documentation') }} {{ index + 1 }}</span>
        <img src="/img/pdf-image.svg" class="pdf-image" />
        <a
          :href="`/storage/${boarding.boarding_pass}`"
          download
          target="_blank"
          class="download-pdf"
          ><span class="mr-1">{{ $t('reservation_area.download') }}</span>
          <svg
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="transform transition-transform duration-500 ease-in-out"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            ></path></svg
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { SET_PASSENGERS_FILLED_ACTION } from "../../store/reserve-area/action-types";
import {
  GET_BOARDING_PASSES,
  GET_LOADING,
  GET_PASSENGERS,
  GET_RESERVATION_CODE,
} from "../../store/reserve-area/getter-types";
import {
  SET_RESERVATION_CODE,
  SET_VALID_CODE_TO_TRUE,
} from "../../store/reserve-area/mutation-types";
import passengerLabel from "../../utils/mixins/passengerLabel";

export default {
  mixins: [passengerLabel],
  props: {
    code: {
      type: String,
    },
  },
  data() {
    return {
      form: {
        valid: false,
        passengers: [],
      },
      appConfig: window.appConfig || 'avm', 
    }
  },
  computed: {
    ...mapGetters({
      passengers: GET_PASSENGERS,
      boarding_passes: GET_BOARDING_PASSES,
      reservationCode: GET_RESERVATION_CODE,
      loading: GET_LOADING,
    }),
    boardingText() {
    return this.appConfig === 'ebm'
      ? this.$t('reservation_area.fill_in_to_get_boarding_ebm')
      : this.$t('reservation_area.fill_in_to_get_boarding');
    },
  },
  methods: {
    ...mapMutations({
      setValidCode: SET_VALID_CODE_TO_TRUE,
      setReservationCode: SET_RESERVATION_CODE,
    }),
    ...mapActions({
      setPassengersFilled: SET_PASSENGERS_FILLED_ACTION,
    }),
    handleSaveData() {
      if (this.validPassengers()) {
        this.setPassengersFilled([this.form.passengers, this.reservationCode]);
      }
    },
    validPassengers() {
      this.form.passengers = [];
      for (let i = 1; i <= this.passengers.length; i++) {
        const ref = "formAdult" + i;
        if (this.$refs[ref][0]) {
          this.form.valid = this.$refs[ref][0].validate();
          if (this.form.valid) {
            let form = JSON.parse(JSON.stringify(this.$refs[ref][0].form));
            this.form.passengers.push({
              name: form.firstName.value,
              lastName: form.lastName.value,
              email: form.email.value,
              type: "adult",
              card_id_type: form.idCard.type.value,
              card_id: form.idCard.number.value,
              date_of_birth: new Date(
                form.birthday.year.value,
                form.birthday.month.value - 1,
                form.birthday.day.value,
                12,
                0,
                0
              ),
              nationality: form.nationality.value,
              phone: form.phone.number.value,
              phone_prefix: form.phone.countryCode.value,
              expiration_date: new Date(
                form.expiration_date.year.value,
                form.expiration_date.month.value - 1,
                form.expiration_date.day.value,
                12,
                0,
                0
              ),
            });
          } else {
            this.$toastr.e(this.$t('toast.error_5'));
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
            return false;
          }
        }
      }
      return true;
    },
  },
  beforeDestroy() {
    this.setValidCode(false);
    this.setReservationCode("");
  },
  created(){
    console.log();
  }
};
</script>

<style lang="scss">
@import "../../../sass/variables";

.reservation-text {
  max-width: 600px;
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 50px auto 37px auto;

  @media (min-width: 1024px) {
    margin-top: 80px;
  }

  .code {
    margin-top: 1.87rem;
    font-family: "Avenir-Heavy";
    font-size: 20px;
    .turquoiseBlue {
      color: $turquoiseBlue;
    }
  }
}

.forms-container {
  max-width: 875px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .save-reservation-btn {
    margin: 2rem auto;
  }
}
.boarding-container {
  display: flex;
  @media (max-width: $breakpoint-landing-phone) {
    flex-direction: column;
    align-items: center;
  }
  .boarding-pass {
    display: flex;
    flex-direction: column;
    margin: 1rem;
    align-items: center;

    .pdf-image {
      max-width: 70px;
      width: 100%;
      margin: 0.5rem;
    }
    .download-pdf {
      display: flex;
      color: $turquoiseBlueContact;
      font-size: 1.125rem;
      align-items: center;
      &:hover {
        color: #06676e;
      }
    }
  }
}
</style>
